<template>
    <form autocomplete="off" class="trax-form-with-icons" v-on:submit.prevent="search">
    
        <!-- Role: the supervisors only see the learner accounts. -->

        <trax-ui-select icon="account_box" v-model="form.role_id" :options="roles_select"
            :unselected="lang.polaris.account.all_roles" v-if="canManage">
        </trax-ui-select>

        <!-- Medical certificate -->

        <trax-ui-toggle :text="lang.polaris.common.medical_certificate_alert" v-model="form.medical_alert">
        </trax-ui-toggle>

        <!-- Submit buttons -->

        <div class="trax-form-actions text-right">
            <button type="button" class="btn btn-default btn-link" @click="reset"> {{ lang.polaris.form.reset }} </button>
            <button type="submit" class="btn btn-primary btn-round"> {{ lang.polaris.form.search }} </button>
        </div>

    </form>
</template>

<script>
    export default {
    
        props: {
            id: null,
            bus: null
        },
        
        data: function() {
            return {
                lang: lang,
                user: user,
                form: {},
                roles_select: data.roles_select
            }
        },

        computed: {

            canManage() {
                return this.user.admin || this.user.permissions['user.manage'] ? true : false;
            }
        },

        created: function() {
            this.bus.$on(this.id+'-filter-restore', data => {
                this.form = data ? data : {};
                // The datatable restores the filters it saved in a previous session, which
                // may hold a role the supervisors can no longer see nor reset.
                if (!this.canManage) delete this.form.role_id;
            })
        },

        methods: {

            search() {
                this.bus.$emit(this.id+'-filter', this.form);
                this.bus.$emit(this.id+'-search-close');
            },

            reset() {
                this.form = {};
                this.search();
            }
        }
            
    }
</script>
